
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"17.086","height":"13.755"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.346 3.205h1.6c8.567.293 8.355 9.224 8.52 9.729a.155.155 0 01-.248.166c-2.582-2.976-3.289-4.9-9.9-4.267a.129.129 0 00-.129.129l-.009 2.336a.13.13 0 01-.221.091l-5.325-5.3a.13.13 0 010-.184L6 .647a.13.13 0 01.22.093l-.009 2.336a.13.13 0 00.135.129z","fill":"none","stroke":"#6b7786","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.2"}})])
          )
        }
      }
    